import { updatePrices, processInitialSocketData } from "@/utils/symbolsSocket";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    quotes: {},
    symbolsData: {},
    initialSocketData: {}, //equivalent to "updatePrice1" function at the website
    socketListenerInitFlag: false,
    chartSymbol: "",
  },
  mutations: {
    setQuotes(state, obj) {
      // state.quotes = {...state.quotes, [obj.s]: obj};
      if(state.quotes[obj.s]){
        state.quotes[obj.s]=obj;
      } else {
        Vue.set(state.quotes, obj.s, obj);
      }
    },
    setInitialSocketData(state, { socketData, symbolData }) {
      const organizedSocketInitData = processInitialSocketData(
        socketData,
        symbolData
      );
      Vue.set(
        state.initialSocketData,
        socketData.symbol,
        organizedSocketInitData
      );
    },
    setSocketListenerInitFlag(state, isListenersInitialized) {
      state.socketListenerInitFlag = isListenersInitialized;
    },
    setChartSymbol(state, symbolDisplayedAtChart) {
      state.chartSymbol = symbolDisplayedAtChart;
    },
  },
  actions: {
    completeSocketInitialization({dispatch }, symbolsList) {
      if(symbolsList){
        dispatch("getInfoFromWebsite", "symbols", {root:true}).then(()=>{
          dispatch("_completeSocketInitialization",symbolsList);
        })
      }
    },
    _completeSocketInitialization({dispatch }, symbolsList) {
      dispatch("initSocketListeners",symbolsList);
      dispatch("emitSocketCalls", symbolsList);
    },
    //todo: obj with "getters" param is not being used and is temporary just to allow fake first arg, try to find better solution
    // eslint-disable-next-line no-unused-vars
    emitSocketCalls ({getters},signalsList) {
      signalsList.forEach(signalName =>{
        window.socket.emit("join", signalName);
        window.socket.emit("symbolPrice", {
          symbol: signalName
        });
      })
    },
    updatePrice({rootState, state, commit},  data ) {
      const symbolData = rootState.symbolsData[data.s];
      const percentage = symbolData ? symbolData.periodD1 : null
      const newQuotes = updatePrices( //here commit
          data,
          state.quotes[data.s],
          percentage
      );
      commit("setQuotes", newQuotes)
    },
    initSocketListeners({ state, commit, rootState,dispatch }) {
      if (!state.socketListenerInitFlag) {
        dispatch("getInfoFromWebsite", "symbols", {root:true}).then(() =>{
          window.socket.on("tick", function(data) {
            const symbol = data.s;
            if (data != null && state.quotes[symbol]) {
              dispatch("updatePrice", data );
            }
            if (typeof gChart !== "undefined" && state.chartSymbol == symbol) {
              window.setTimeFrame(
                  data.t,
                  window.gChart.chartPeriod,
                  data.b,
                  symbol,
                  rootState.symbolsData[symbol].digits
              ); //note: digits parameter is using data from "get-symbols" service (and not from the socket by data.d) just as was done at the original version at the website.
            }
          });
          window.socket.on("symbolPrice", function(data) {
            if (data != undefined) {
              var obj = {
                a: data.ask,
                b: data.bid,
                ca: "grey_color",
                cb: "grey_color",
                d: data.digits,
                s: data.symbol,
                percentColor: "",
                percentValue: ""
              };
              commit("setQuotes", obj);
              dispatch("updatePrice", obj );
              commit("setInitialSocketData", {
                socketData: data,
                symbolData: rootState.symbolsData[data.symbol]
              });
            }
          });
          commit("setSocketListenerInitFlag", true);
        });
      }
    }
  }
};
